<template>
  <a-config-provider :locale="zhCN">
    <router-view :key="$route.fullPath" />
  </a-config-provider>
</template>

<script lang="ts" setup>
defineOptions({ name: 'App' });

import zhCN from 'ant-design-vue/es/locale/zh_CN';
//  组件提供的语言包并不对日期格式化起作用，需要额外导入 moment 语言包
import moment from 'moment';
import 'moment/dist/locale/zh-cn';

moment.locale('cn');
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
  html,body{
    overflow: hidden;
  }
</style>
